import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutComponent } from 'src/app/view/about/about.component';
import { OverviewComponent } from 'src/app/view/about/overview/overview.component';
import { VisionComponent } from 'src/app/view/about/vision/vision.component';
import { DirectorComponent } from 'src/app/view/about/director/director.component';
import { PrincipalComponent } from 'src/app/view/about/principal/principal.component';
import { TeamComponent } from 'src/app/view/about/team/team.component';
import { StudentCouncilComponent } from 'src/app/view/about/student-council/student-council.component';
import { FacilitiesComponent } from 'src/app/view/about/facilities/facilities.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    AboutComponent,
    OverviewComponent,
    VisionComponent,
    DirectorComponent,
    PrincipalComponent,
    TeamComponent,
    StudentCouncilComponent,
    FacilitiesComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {path:'',component:AboutComponent, children:[
        {path:'overview',component:OverviewComponent},
        {path:'vision',component:VisionComponent},
        {path:'director',component:DirectorComponent},
        {path:'principal',component:PrincipalComponent},
        {path:'team',component:TeamComponent},
        {path:'student-council',component:StudentCouncilComponent},
        {path:'facilities',component:FacilitiesComponent},
      ]}
    ]),
    SharedModule
  ]
})
export class AboutModule { }
